import React from 'react';

import { Link } from '../../Link';

export const SupportMenu = () => {
  return (
    <>
      <p>SUPORTE</p>
      <ul>
        <li>
          <Link target="_blank" to="https://pagarme.helpjuice.com/">
            FAQ
          </Link>
        </li>
        <li>
          <Link target="_blank" to="https://docs.pagar.me/page/guias-pagarme">
            Guias de integração
          </Link>
        </li>
        <li>
          <Link target="_blank" to="https://docs.pagar.me/">
            Documentação
          </Link>
        </li>
        <li>
          <Link to="/boletos">Boleto DDA</Link>
        </li>
      </ul>
    </>
  );
};
